var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "networong-page", attrs: { id: "page_Container" } },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          {
            staticStyle: { "text-align": "center" },
            attrs: { id: "main-container" }
          },
          [
            _c("div", { staticClass: "tips" }, [
              _vm._v("网络出现异常，加载不出来啦～")
            ]),
            _vm._v(" "),
            _c(
              "van-button",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { plain: "", round: "", type: "danger" },
                on: { click: _vm.backClick }
              },
              [_vm._v("立即刷新")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }